// little helper to generate a sequence of numbers as an array
const getPagesArray = (start: number, end: number) => {
  const setPages = [] as number[];
  for (start > 0 ? start : 1; start <= end; start++) {
    setPages.push(start);
  }

  return setPages;
};

// Sentinel returned in place of a page number to mark an ellipsis (...) gap.
const ELLIPSIS = -1;

// Every truncated layout renders exactly seven slots, so anything up to this
// many pages is shown in full without an ellipsis.
const MAX_VISIBLE = 7;

/**
 * Builds the sequence of pagination items to render. Page numbers are returned
 * as-is; each ellipsis gap is returned as {@link ELLIPSIS} (-1).
 *
 * Three layouts, all seven slots wide once truncation kicks in:
 * - near the start (`current <= 4`): `1 2 3 4 5 … total`
 * - near the end (`current >= total - 3`): `1 … total-4 total-3 total-2 total-1 total`
 * - in between: `1 … current-1 current current+1 … total`
 *
 * The start/end thresholds are chosen so an ellipsis never hides just a single
 * page, which would waste a slot on a gap the same width as the page it hides.
 *
 * @param current active page number
 * @param total number of available pages
 */
export const getPages = (current: number, total: number) => {
  if (total <= MAX_VISIBLE) {
    return getPagesArray(1, total);
  }

  // Near the start: the first five pages already include the active one.
  if (current <= 4) {
    return [...getPagesArray(1, 5), ELLIPSIS, total];
  }

  // Near the end: the last five pages already include the active one.
  if (current >= total - 3) {
    return [1, ELLIPSIS, ...getPagesArray(total - 4, total)];
  }

  // In between: the active page sits centred between two ellipsis gaps.
  return [1, ELLIPSIS, current - 1, current, current + 1, ELLIPSIS, total];
};
